import { render, staticRenderFns } from "./PrizesShow.vue?vue&type=template&id=627b42f6&scoped=true"
import script from "./PrizesShow.vue?vue&type=script&lang=js"
export * from "./PrizesShow.vue?vue&type=script&lang=js"
import style0 from "./PrizesShow.vue?vue&type=style&index=0&id=627b42f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b42f6",
  null
  
)

export default component.exports